<template>
  <div class="active-requests-sidebar md-elevation-2">
    <!-- Heading -->
    <div class="sidebar-heading">
      {{ $t('activeRequestsByCountry') }}
    </div>
    <!-- Country List with Active Requests -->
    <ul class="md-list">
      <li
        v-for="requestCountry in activeRequestsCountByCountry"
        :key="requestCountry"
        class="md-list-item"
        @click="selectCountry(requestCountry.country)"
      >
        <div class="d-flex justify-content-between align-items-center w-100">
          <div class="md-chip md-chip-primary">
            {{ $t(`countries.${requestCountry.country}`) }}
          </div>
          <div class="md-chip md-chip-outlined">
            {{ requestCountry.numberOfRequests }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    // Expecting an object where key is country name and value is count of active requests
    activeRequestsCountByCountry: {
      type: Array,
      required: true
    }
  },
  methods:{
    selectCountry(country) {
      // Emit the event with the country code
      this.$emit('country-selected', country);
    }
  }
}
</script>

<style lang="scss" scoped>
// Material Design Variables
$md-primary: #1565C0;
$md-primary-dark: #0D47A1;
$md-primary-light: #90CAF9;
$md-secondary: #C2185B;
$md-success: #2E7D32;
$md-warning: #F57F17;
$md-error: #C62828;
$md-surface: #FFFFFF;
$md-background: #F5F5F5;
$md-on-primary: #FFFFFF;
$md-on-secondary: #FFFFFF;
$md-on-surface: #212121;
$md-on-background: #212121;

// Material Design Typography
$md-font-family: Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
$md-font-weight-regular: 400;
$md-font-weight-medium: 500;
$md-font-weight-bold: 700;

// Material Design Elevation
.md-elevation-2 {
  border-radius: 8px;
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}

// Material Design Chips
.md-chip {
  display: inline-flex;
  align-items: center;
  padding: 0 12px;
  height: 32px;
  font-size: 14px;
  font-weight: $md-font-weight-medium;
  border-radius: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &-primary {
    background-color: $md-primary;
    color: $md-on-primary;
  }

  &-outlined {
    background-color: transparent;
    border: 1px solid rgba(0, 0, 0, 0.12);
    color: $md-on-surface;
  }
}

// Component Styles
.active-requests-sidebar {
  background-color: $md-surface;
  padding: 16px;
  margin-top: 16px;
  height: calc(100vh - 32px);
  overflow-y: auto;
  font-family: $md-font-family;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12);
  }
}

.sidebar-heading {
  font-size: 18px;
  font-weight: $md-font-weight-medium;
  margin-bottom: 16px;
  text-align: center;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  color: $md-on-surface;
  letter-spacing: 0.15px;
}

.md-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.md-list-item {
  padding: 12px 16px;
  margin-bottom: 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: $md-surface;
  border: 1px solid rgba(0, 0, 0, 0.08);

  &:hover {
    background-color: rgba($md-primary, 0.05);
    transform: translateY(-2px);
    box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
  }
}

@media (max-width: 768px) {
  .active-requests-sidebar {
    height: auto;
    max-height: 50vh;
  }

  .md-list-item {
    .d-flex {
      flex-direction: column;
      align-items: flex-start !important;

      .md-chip {
        margin-bottom: 8px;
      }
    }
  }
}
</style>
